module.exports = __webpack_public_path__ + "static/media/00121000.7ce61865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/00121000.jpg
// module id = 166
// module chunks = 0